module.exports = __webpack_public_path__ + "img/p3_14.7e6ea773.png";